<!--  -->
<template>
  <div class="regBody" id="body" v-loading="isLoad">
    <div>
    </div>
    <div style="display: flex; height: 100vh !important; justify-content: center">
      <div class="formClass" style="display: inline-block; overflow: scroll; height: auto"
        :style="{ width: formWidth }">

        <div>
        </div>
        <el-collapse v-model="openData">
          <el-collapse-item name="1" size="mini" class="title">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-info"></i>案件基本信息
                <a name="baseInfo" id="baseInfoId" style="height: 0px"></a>
              </div>
            </template>
            <div class="form-content">
              <el-form :inline="true" :model="caseInfo" ref="baseForm" :rules="baseRules" label-width="100px"
                class="demo-ruleForm">
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="案号" prop="registerCode" label-width="10rem">
                      <el-input v-model="caseInfo.registerCode" style="width: 11rem"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="批次号" label-width="10rem">
                      <el-input v-model="caseInfo.batchId" style="width: 11rem"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="立案案由" label-width="10rem">
                      <el-input readonly="" v-model="cause" style="width: 11rem"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="法院名称" prop="courtName" label-width="10rem">
                      <el-select clearable style="width: 11rem" v-model="caseInfo.courtName" placeholder="请选择法院">
                        <el-option v-for="item in courtName" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="标的" label-width="10rem">
                      <el-input type="number" v-model="caseInfo.underlyingAmount" style="width: 11rem"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="案件状态" prop="caseStatus" label-width="10rem">
                      <el-select @change="switchStatus" clearable v-model="caseInfo.caseStatus" placeholder="请选择"
                        style="width: 11rem">
                        <el-option label="未处置" value="未处置"></el-option>
                        <el-option label="处置中" value="处置中"></el-option>
                        <el-option label="提交诉讼服务网" value="提交诉讼服务网"></el-option>
                        <el-option label="提交法院" value="提交法院"></el-option>

                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>

                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="创建日期" label-width="10rem">
                      <el-date-picker style="width: 11rem; width: 11rem" v-model="caseInfo.entrustmentDate" type="date"
                        value-format="yyyy-MM-dd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="提交法院日期" label-width="10rem" prop="courtSubDate">
                      <el-date-picker style="width: 11rem" v-model="caseInfo.courtSubDate" type="date"
                        value-format="yyyy-MM-dd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <!-- <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="律师费" label-width="10rem">
                      <el-input type="number" v-model="caseInfo.lawyerFee" style="width: 11rem"></el-input>
                    </el-form-item>
                  </el-col> -->
                  <!-- <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="是否还清" label-width="10rem">
                      <el-radio-group v-model="caseInfo.isRepayment" style="width: 11rem">
                        <el-radio label="是"></el-radio>
                        <el-radio label="否"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col> -->
                </el-row>

                <div style="width: 200px; margin: 0 auto">
                  <el-button type="primary" @click="submitBaseForm('baseForm')">保存案件基本信息</el-button>
                </div>
              </el-form>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2" class="title">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-check"></i>
                当事人信息
                <el-button type="success" size="mini" plain round style="margin: 10px 0"
                  @click.stop="addPlaintiff(caseInfo.id)">+添加原告</el-button>
                <el-button type="success" size="mini" plain round style="margin: 10px 0"
                  @click.stop="addDefendant(caseInfo.id)">
                  +添加被告</el-button>
                <!-- <a name="pla" id="plaId"></a>
                <a name="def" id="defId"></a> -->
              </div>
            </template>
            <div style="" class="form-content">


              <el-collapse v-model="plaNames">
                <div v-for="(item, index) in plaList" :key="index + 'party1'">

                  <el-collapse-item :name="item.id">
                    <template slot="title" style="background-color: #e6eaed">
                      <div class="itemName">(原告){{ item.name }}</div>
                    </template>
                    <el-form :inline="true" :model="item" :rules="plaRules" ref="plaForm" label-width="100px"
                      class="demo-ruleForm">
                      <el-row>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="当事人类型" prop="partiesType" label-width="10rem">
                            <el-radio-group v-model="item.partiesType" style="width: 11rem">
                              <el-radio label="自然人"></el-radio>
                              <el-radio label="企业"></el-radio>
                            </el-radio-group> </el-form-item></el-col>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item prop="litigationStatus" label="诉讼地位" label-width="10rem">
                            <el-radio-group v-model="item.litigationStatus" style="width: 11rem">
                              <el-radio label="原告"></el-radio>
                              <el-radio label="被告"></el-radio>
                            </el-radio-group> </el-form-item></el-col>
                      </el-row>
                      <el-row>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="公司" prop="name" label-width="10rem">
                            <el-input v-model="item.name" style="width: 11rem"></el-input> </el-form-item></el-col>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item prop="idCard" label="社会统一信用代码" label-width="10rem">
                            <el-input v-model="item.idCard" style="width: 11rem"></el-input> </el-form-item></el-col>
                      </el-row>
                      <el-row>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="法定代表人" prop="legalRepresentative" label-width="10rem">
                            <el-input v-model="item.legalRepresentative" style="width: 11rem"></el-input>
                          </el-form-item></el-col>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="负责人身份证" prop="legalRepresentativeIdCard" label-width="10rem">
                            <!-- @input="
                                        (e) => {
                                          inputIdCard(e, '.ygIdCard');
                                        }
                                      " -->
                            <el-input v-model="item.legalRepresentativeIdCard" style="width: 11rem"></el-input>
                            <div class="ygIdCard" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              身份证不符合
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="职务" prop="post" label-width="10rem">
                            <el-input v-model="item.post" style="width: 11rem"></el-input> </el-form-item></el-col>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="手机号码" prop="phone" label-width="10rem">
                            <!-- @input="
                                        (e) => {
                                          inputPhone(e, '.ygPhone');
                                        }
                                      " -->
                            <el-input type="tel" v-model="item.phone" style="width: 11rem"></el-input>
                            <div class="ygPhone" style="
                                font-size: 12px;
                                height: 10px;
                                color: #f56c6c;
                                display: none;
                                margin-left: 20px;
                              ">
                              手机号不符合
                            </div>
                          </el-form-item></el-col>
                      </el-row>

                      <el-row>
                        <el-col :span="24" style="height: 60px">
                          <el-form-item label="公司住所地" label-width="10rem" prop="address">
                            <el-input v-model="item.address" style="width: 30rem"></el-input> </el-form-item></el-col>
                        <el-col :span="24" style="height: 60px">
                          <el-form-item label="送达地址" label-width="10rem" prop="serviceAddress">
                            <el-input v-model="item.serviceAddress" style="width: 30rem"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                          :span="spanWidth" style="height: 60px">
                          <el-form-item label="邮箱/客户号" label-width="10rem">
                            <el-input type="email" v-model="item.email" style="width: 11rem"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <div style="width: 20rem; margin: 0 auto">
                        <el-button v-if="item.id <= 0" type="primary"
                          @click="saveOfUpdatePartyInfo(item, 'plaForm', index)">新增原告</el-button>
                        <el-button type="primary" v-else
                          @click="saveOfUpdatePartyInfo(item, 'plaForm', index)">更新原告</el-button>
                        <el-button type="danger" @click="deletePartyInfo(index, 'pla')">删除原告</el-button>
                      </div>
                    </el-form>
                    <!-- </div> -->
                  </el-collapse-item>
                </div>
              </el-collapse>

              <el-collapse v-model="defNames">
                <div v-for="(item, index) in defList" :key="index + 'party2'">
                  <el-collapse-item style="" :name="item.id">
                    <template slot="title">
                      <div class="itemName">(被告){{ item.name }}</div>
                    </template>

                    <div>
                      <el-form :inline="true" :model="item" ref="defForm" :rules="defRules" label-width="100px"
                        class="demo-ruleForm">
                        <el-row>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="当事人类型" prop="partiesType" label-width="10rem">
                              <el-radio-group v-model="item.partiesType" style="width: 11rem">
                                <el-radio label="自然人"></el-radio>
                                <el-radio label="企业"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="诉讼地位" label-width="10rem" prop="litigationStatus">
                              <el-radio-group v-model="item.litigationStatus" style="width: 11rem">
                                <el-radio label="原告"></el-radio>
                                <el-radio label="被告"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="名字" prop="name" label-width="10rem">
                              <el-input v-model="item.name" style="width: 11rem"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="公民身份号码" prop="idCard" label-width="10rem">
                              <el-input @input="getBirthdayAndSex(item.idCard, index)" v-model="item.idCard"
                                style="width: 11rem"></el-input>
                              <div class="bgIdCard" style="
                                  font-size: 12px;
                                  height: 10px;
                                  color: #f56c6c;
                                  display: none;
                                  margin-left: 20px;
                                ">
                                身份证不符合
                              </div>
                            </el-form-item></el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="性别" prop="sex" label-width="10rem">
                              <el-radio-group v-model="item.sex" style="width: 11rem">
                                <el-radio label="男"></el-radio>
                                <el-radio label="女"></el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="出生日期" prop="birthday" label-width="10rem">
                              <el-date-picker placeholder="选择时间" type="date" v-model="item.birthday"
                                style="width: 11rem" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="民族" prop="nation" label-width="10rem">
                              <el-input v-model="item.nation" style="width: 11rem">
                                <template slot="append">族</template>
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }"
                            :span="spanWidth" style="height: 60px">
                            <el-form-item label="手机号码" prop="phone" label-width="10rem">
                              <!-- @input="
                                        (e) => {
                                          inputPhone(e, '.bgPhone');
                                        }
                                      " -->
                              <el-input type="tel" v-model="item.phone" style="width: 11rem"></el-input>
                              <div class="bgPhone" style="
                                  font-size: 12px;
                                  height: 10px;
                                  color: #f56c6c;
                                  display: none;
                                  margin-left: 20px;
                                ">
                                手机号不符合
                              </div>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24" style="height: 60px">
                            <el-form-item prop="address" label="户籍地址" label-width="10rem">
                              <el-input v-model="item.address" style="width: 43vw"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="24" style="height: 60px">
                            <el-form-item label="送达地址" label-width="10rem" prop="serviceAddress">
                              <el-input v-model="item.serviceAddress" style="width: 43vw"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>


                        </el-row>

                        <div></div>
                        <div class="center">
                          <el-button v-if="item.id <= 0" type="primary" @click="
    saveOfUpdatePartyInfo(item, 'defForm', index)
    ">新增被告</el-button>
                          <el-button v-else type="primary" @click="
    saveOfUpdatePartyInfo(item, 'defForm', index)
    ">更新被告</el-button>
                          <el-button @click="deletePartyInfo(index, 'def')" type="danger">删除被告</el-button>
                        </div>
                      </el-form>
                    </div>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </div>
          </el-collapse-item>



          <el-collapse-item name="3">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-claim"></i>
                要素信息
                <a name="fenqi" id="fenqiId"></a>
              </div>
            </template>
            <div style="margin-top: 50px" class="form-content">
              <el-form :inline="true" ref="elementForm" :model="element" label-width="100px" :rules="ysRules"
                class="demo-ruleForm">
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="签约合同名称" label-width="10rem" prop="contractName">
                      <el-input style="width: 43vw" v-model="element.contractName"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 24 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="违约条款" label-width="10rem" prop="clause">
                      <el-input style="width: 43vw" v-model="element.clause"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="合同签订时间" label-width="10rem" prop="contractDate">
                      <el-date-picker style="width: 11rem" v-model="element.contractDate" type="date"
                        value-format="yyyy-MM-dd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="违约日期" label-width="10rem" prop="liquidatedDate">
                      <el-date-picker style="width: 11rem" v-model="element.liquidatedDate" type="date"
                        value-format="yyyy-MM-dd" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>


                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="签订年限" label-width="10rem" prop="contractYear">
                      <el-input type="number" style="width: 11rem" v-model="element.contractYear"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth">
                    <el-form-item label="合同违约金" label-width="10rem" prop="contractLiquidatedDamages">
                      <el-input style="width: 11rem" v-model="element.contractLiquidatedDamages"></el-input>
                    </el-form-item>

                  </el-col>



                </el-row>
                <el-row>
                  <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }" :span="spanWidth"
                    style="height: 60px">
                    <el-form-item label="起诉违约金" label-width="10rem" prop="liquidatedDamages">
                      <el-input style="width: 11rem" v-model="element.liquidatedDamages"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div></div>
                <div class="center">
                  <el-button style="height:40px" type="primary" @click="saveOfUpdateElement()">保存要素信息</el-button>
                </div>
              </el-form>
            </div>
          </el-collapse-item>

          <!-- <iframe :src="docx" marginWidth="0" marginHeight="0" scrolling="no" frameBorder="0" style="width: calc(100% + 17px); height: calc(100% + 17px)"></iframe>
          <img :src="docx">
          <div v-if="showDoc" class="docxRef" style="width: 100%; height: 100vh"></div> -->

          <el-collapse-item name="4" style="height: 200px">
            <template slot="title">
              <div class="caseInfoItemHead">
                <i class="header-icon el-icon-s-claim"></i>
                文件列表
                <a name="fenqi" id="fenqiId"></a>
              </div>
            </template>
            <div class="form-content" style="overflow:auto;margin-bottom:100px">
              <el-card class="box-card" v-for="item in fileDataList" :key="item.id">
                <div slot="header" class="clearfix">
                  <span>{{ item.fileName }}</span>
                  <el-button v-permission:function="['liveCase_downLoadCaseFile']"
                    @click="downCaseUploadFile(item.id, item.fileName)" style="float: right; padding: 3px 0"
                    type="text">下载</el-button>
                  <el-button v-permission:function="['liveCase_deleteCaseFile']" @click="deleteCaseUploadFile(item.id)"
                    style="float: right; padding: 3px 10px" type="text">删除</el-button>
                </div>
              </el-card>
            </div>

          </el-collapse-item>
        </el-collapse>
        <div style="height:100px;overflow:auto">

        </div>
      </div>
    </div>



    <div></div>
  </div>
</template>

<script>

import {
  ocrReq,
} from "@/api/czManager/register/index";

//引入VueOfficeDocx组件
//引入相关样式
// import "@vue-office/docx/lib/index.css";
import { downLoadFile, getPreviewFile } from '@/plugin/axios'
import {
  addCaseInfo,
} from "@/api/czManager/czCaseInfo/index";
import {
  getLiveCaseInfo,
  updateLiveCaseInfo,
  addParty,
  updateParty,
  deleteParty,
  addElement,
  updateElement,
  deleteElement,
  getFileList,
  deleteCaseUploadFile
} from "@/api/czManager/liveCaseInfo/index";
import { ocrCard } from "@/utils/ocrText.js";
import { guid } from "@/utils/index";
import util from "@/libs/util";
import axios from "axios";
import { validatePhone, validateCardId } from "@/utils/myUtils/validate";
var validateId = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("身份证不能为空"));
  } else if (!validateCardId(value)) {
    callback("身份证格式不对");
  } else {
    callback();
  }
};
var validatePh = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  } else if (!validatePhone(value)) {
    callback("手机号格式不对");
  } else {
    callback();
  }
};

export default {
  //import引入的组件需要注入到对象中才能使用

  props: ["id"],
  data() {
    //这里存放数据
    return {
      showDoc: false,
      element: {
        id: '',
        caseId: '',
        contractYear: 0
      },
      party: [],
      responsibility: ["抵押责任", "担保责任", "共同还款责任"],
      ysRules: {
        contractName: [{
          required: true, message: "请输入合同名称", trigger: 'blur'

        }],
        contractDate: [{
          required: true, message: '请选择合同签订日期', trigger: 'change'
        }],
        liquidatedDate: [{
          required: true, message: '请选择合同违约日期', trigger: 'change'
        }],
        contractYear: [{
          required: true, message: '请选择合同签订年限', trigger: 'blur'
        }],
        contractLiquidatedDamages: [{
          required: true, message: '请输入合同违约金', trigger: 'blur'
        }],
        liquidatedDamages: [{
          required: true, message: '请输入起诉违约金', trigger: 'blur'
        }],
        clause: [{
          required: true, message: "请输入违约条款", trigger: 'blur'
        }]
      },
      climit: 10,
      ckey: "",
      showDoc: false,
      cid: "",
      openData: [],
      openProduct: [],
      openCard: [],
      openDiya: [],
      textTip: "预览文书",
      spanWidth: 12,

      applicationType: [],
      loading: false,
      editorOptions: {
        height: "60%",
      },
      docWidth: "50%",
      formWidth: "100%",
      docx: "",
      currentIndex: 0,
      isLoad: false,
      fileList: [],
      fenQi: [],
      productNameList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      czInsForm: {
        installmentType: "",
        stagesScheme: "",
        loanDate: "",
        borrowingSum: "",
        borrowingChargeSum: "",
        installmentSum: "",
        chargeRate: "",
        billDate: "",
        billMoney: "",
      },
      caseBaserules: {
        applicationDate: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      stagesScheme: [],
      areementList: [],
      defNames: [],
      plaNames: [],
      plaAgentNames: [],
      defAgentNames: [],
      cardNames: [],
      eviNames: [],
      activeNames: ["1"],
      active: 1,
      caseStatus: [],
      plaList: [],
      plaAgentList: [],
      defAgentList: [],

      defList: [],
      defRelationship: ["夫妻关系", "亲属关系"],
      phoneFlag: false,
      idCardFlag: false,
      caseInfo: {


      },
      cause: "劳务合同纠纷",

      baseRules: {
        courtSubDate: [
          {
            required: false,
            message: "请选择提交法院日期",
            trigger: "change",
          },
        ],
        batchId: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        courtName: [
          { required: true, message: "请选择法院", trigger: "change" },
        ],
        caseStatus: [
          { required: true, message: "请选择案件状态", trigger: "change" },
        ],
      },

      plaRules: {
        partiesType: [
          { required: true, message: "请选择案件类型", trigger: "change" },
        ],
        litigationStatus: [
          {
            required: true,
            message: "请选择诉讼地位",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "blur",
          },
        ],
        serviceAddress: [
          { required: true, message: "请输入送达地址", trigger: "blur" },
        ],
        address: [
          {
            required: true,
            message: "请输入户籍地/公司所在地",
            trigger: "blur",
          },
        ],
        legalRepresentative: [
          {
            required: true,
            message: "请输入法定代表人",
            trigger: "blur",
          },
        ],
        post: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur",
          },
        ],
        legalRepresentativeIdCard: [
          {
            validator: validateId,
            required: true,
            // message: "请输入负责人身份证",
            // trigger: "blur",
          },
        ],
      },
      defRules: {
        responsibility: [
          { required: false, message: "请选择还款责任", trigger: "change" },
        ],
        defRelationship: [
          { required: false, message: "请选择被告关系", trigger: "change" },
        ],
        partiesType: [
          { required: true, message: "请选择案件类型", trigger: "change" },
        ],
        litigationStatus: [
          {
            required: true,
            message: "请选择诉讼地位",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名字",
            trigger: "blur",
          },
        ],
        idCard: [{ required: true, validator: validateId }],

        birthday: [
          {
            required: true,
            message: "请选择出生日期",
            trigger: "change",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        nation: [{ required: true, message: "请输入民族", trigger: "blur" }],
        phone: [{ required: true, validator: validatePh }],
        serviceAddress: [
          { required: true, message: "请输入送达地址", trigger: "blur" },
        ],
        address: [
          {
            required: true,
            message: "请输入户籍地/公司所在地",
            trigger: "blur",
          },
        ],
      },

      defAgentRules: {
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change",
          },
        ],
        agentType: [
          {
            required: true,
            message: "请选择第一代理人类型",
            trigger: "change",
          },
        ],
        agentName: [
          {
            required: true,
            message: "请输入代理人名",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            validator: validateId,
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePh,
          },
        ],
        lawyerLicenseNo: [
          {
            required: true,
            message: "请输",

            trigger: "blur",
          },
        ],
        lawfirmName: [
          {
            required: true,
            message: "请输代理人所在律所名称",
            trigger: "blur",
          },
        ],
      },
      fileData: new FormData(),
      fileDataList: [],

      caseBaserules: {
        applicationDate: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      closeBtn: false,
      courtName: [],
      sex: "男",
      birthday: "",
      carIndex: "",
      cindex: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化

  //方法集合
  methods: {
    deleteCaseUploadFile(id) {
      this.$confirm("是否删除?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }).then((res) => {
        deleteCaseUploadFile(id).then((res) => {

          if (res.statusCode == 2000) {
            this.$message({ message: "删除成功", type: "success", });
          }
          this.getList()
        });
      });
    },
    downCaseUploadFile(id, name) {
      getPreviewFile(this, {
        method: 'get', url: '/api/case/liveCaseFiles/download/' + id, type:
          name.split('.')[1]
      })
      return;
      downLoadFile(this, { method: 'get', url: '/api/case/liveCaseFiles/download/' + id, isValidate: true, fileNum: 0 },
        (req) => { return req })
      return
    },
    deleteElement(id) {

      this.$alert("确定要删除这部分数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            deleteElement(id).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  duration: 5000,
                  message: "删除成功",
                  type: "info",
                });
                Object.keys(this.element).forEach(
                  (key) => (this.element[key] = "")
                );
                this.element.caseId = this.id
                this.getList();
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            });
          }
        },
      });
    },
    saveOfUpdateElement() {
      this.$refs['elementForm'].validate((valid) => {
        if (valid) {
          if (this.element.id == '' || this.element.id == undefined) {
            addElement(this.element).then(res => {
              if (res.statusCode == 2000) {
                this.$message.success('添加成功')
                this.getList()

              }
            })
          } else {
            updateElement(this.element).then(res => {
              if (res.statusCode == 2000) {
                this.$message.success('修改成功')
                this.getList()

              }
            })
          }
        }
      })
    },
    getFileList() {
      this.fileDataList = []
      getFileList(this.id).then(res => {
        if (res && res.length > 0) {
          this.fileDataList = res
          if (this.openData.indexOf("4")) {
            this.openData.push('4')

          }
        }

      })
    },
    getList() {
      // this.getElement()
      // this.getParty(this.id)
      this.getLiveCaseInfo()
      this.getFileList()
    },
    getElement(eleObj) {
      this.element = eleObj
      if (this.openData.indexOf("3")) {
        this.openData.push('3')
      }
    },
    getParty(partyList) {
      this.plaList = []
      this.defList = []
      for (let i = 0; i < partyList.length; i++) {
        if (partyList[i].litigationStatus == "原告") {
          this.plaList.push(partyList[i]);
        } else {
          this.defList.push(partyList[i]);
        }
      }
      if (this.defList.length > 0) {

        if (this.openData.indexOf("2")) {

          this.openData.push("2");
        }

        for (let j = 0; j < this.defList.length; j++) {
          this.defNames.push(this.defList[j].id);
        }
      }

    },

    getLiveCaseInfo() {
      getLiveCaseInfo(this.id).then(res => {
        this.caseInfo = res
        if (this.caseInfo) {
          if (this.openData.indexOf("1")) {
            this.openData.push("1");
          }
        }
        if (res.partyList) {
          this.getParty(res.partyList)
        }
        if (res.liveCaseElement) {
          this.getElement(res.liveCaseElement)
        }
        // this.getElement(res.liveCaseElement)
      })
    },
    rendered() {
      this.loading = false;
    },
    don1() { },
    closeDoc() {
      this.spanWidth = 12;
    },
    HttpUploadFile(val) {
      // this.$refs.upload2.submit();
      this.isLoad = true;
      this.fileData.append("field", val.file);
      const token = util.cookies.get("token");
      ocrReq(this.fileData, token).then((res) => {
        if (
          res.data.data == "" ||
          res.data.data == undefined ||
          res.data.data == null
        ) {
          this.$message.error("识别失败");
          return;
        }
        this.fileData = new FormData();
        this.$message.success("识别成功");
        let card = ocrCard(res.data.data);
        Object.assign(this.caseInfo.cardInfoList[this.carIndex], card);
      });
      this.isLoad = false;
    },
    getIndex(index) {
      this.carIndex = index;
    },
    getOcrloadUrl(index) {
      return process.env.VUE_APP_API + "/api/ocr/ocrRecord/identifyEveryFile";
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
      this.fileData.append("fields", file); // append增加数据
    },
    inputPhone(val, id) {
      if (val == "") return;
      let flag = validatePhone(val);
      if (!flag) {
        document.querySelector(id).style.display = "block";
        this.phoneFlag = true;
      } else {
        this.phoneFlag = false;
        document.querySelector(id).style.display = "none";
      }
    },
    inputIdCard(val, id) {
      if (val == "") return;
      let flag = validateCardId(val);
      if (!flag) {
        this.idCardFlag = true;
        document.querySelector(id).style.display = "block";
      } else {
        this.idCardFlag = false;
        document.querySelector(id).style.display = "none";
      }
    },
    inputCard(val, id) {
      if (val == "") return;
      if (val != null && val != undefined) {
        if (val.length < 16 || val.length.length > 16) {
          document.querySelector(id).style.display = "block";
        } else {
          document.querySelector(id).style.display = "none";
        }
      }
    },
    accountDateChange(val) {
      if (val != null && val != undefined && val != "") {
        this.cardRules["accountDestroyDate"][0].required = true;
        this.cardRules["accountDestroyEndDate"][0].required = true;
      } else {
        this.cardRules["accountDestroyDate"][0].required = false;
        this.cardRules["accountDestroyEndDate"][0].required = false;
      }
    },
    switchStatus(val) {
      if (val == "提交法院") {
        this.baseRules["courtSubDate"][0].required = true;
      }
    },
    getBirthdayAndSex(val, index) {
      if (val.length >= 14) {
        let temp = val.substring(6, 10);
        temp += "-" + val.substring(10, 12);
        temp += "-" + val.substring(12, 14);
        this.birthday = temp;
        this.defList[index].birthday = this.birthday;
      }
      if (val.length >= 17) {
        this.sex = val.substring(16, 17) % 2 == 1 ? "男" : "女";
        this.defList[index].sex = this.sex;
      }
    },
    handleChange(val) { },
    replaceMoney(value, name, index) {
      let val = "" + value;
      val =
        val
          .replace(/[^\d^\.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      this.caseInfo.cardInfoList[index][name] = val;
    },
    replaceObjectMoney(value, name) {
      let val = "" + value;
      val =
        val
          .replace(/[^\d^\.]+/g, "")
          .replace(/^0+(\d)/, "$1")
          .replace(/^\./, "0.")
          .match(/^\d*(\.?\d{0,2})/g)[0] || "";
      this.caseInfo.czInstallment[name] = val;
    },
    saveOfUpdatePartyInfo(item, formName, index) {
      this.$refs[formName][index].validate((valid) => {
        if (valid) {
          if (item.id < 0) item.id = "";

          let str = item.nation;
          if (str != null && str != "") item.nation = str.replace(/族/g, "");
          if (item.id == '' || item.id == undefined) {
            addParty(item).then((response) => {
              if (response.statusCode == 2000) {
                this.$message({
                  duration: 5000,
                  message: "操作成功",
                  type: "success",
                });
                this.getList()
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            });
          } else {
            updateParty(item).then(response => {
              if (response.statusCode == 2000) {
                this.$message({
                  duration: 5000,
                  message: "操作成功",
                  type: "success",
                });
                this.getList()
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }
            })
          }
        } else {
          document.querySelector(".bgIdCard").style.display = "none";
          document.querySelector(".bgPhone").style.display = "none";
          document.querySelector(".ygPhone").style.display = "none";
          document.querySelector(".ygIdCard").style.display = "none";
        }
      });
    },

    addDefendant(id) {
      this.defList.push({
        address: "",
        agentId: 0,
        agreedDeliveryAddress: "",
        birthday: "",
        caseId: id,
        createTime: "",
        // defRelationship: "",
        editTime: "",
        email: "",
        founder: "",
        id: guid() * -1,
        idCard: "",
        legalRepresentative: "",
        litigationStatus: "被告",
        name: "",
        nation: "",
        operator: "",
        partiesType: "自然人",
        phone: "",
        post: "",
        // responsibility: "",
        serviceAddress: "",
        sex: "",
      });
      // this.defNames = this.defList[this.defList.length - 1].id;
      this.defNames.push(this.defList[this.defList.length - 1].id);
      if (this.openData.indexOf("2")) {
        this.openData.push("2");
      }
    },
    addPlaintiff(id) {
      this.plaList.push({
        address: "",
        agentId: 0,
        agreedDeliveryAddress: "",
        birthday: "",
        caseId: id,
        createTime: "",
        defRelationship: "",
        editTime: "",
        email: "",
        founder: "",
        id: guid() * -1,
        idCard: "",
        legalRepresentative: "",
        litigationStatus: "原告",
        name: "",
        nation: "",
        operator: "",
        partiesType: "企业",
        phone: "",
        post: "",
        responsibility: "",
        serviceAddress: "",
        sex: "",
      });
      // let temp = this.plaNames;
      this.plaNames.push(this.plaList[this.plaList.length - 1].id);
      if (this.openData.indexOf("2")) {
        this.openData.push("2");
      }
      // this.plaNames = temp;
      // this.plaNames.push(this.plaList[this.plaList.length - 1].id);
    },
    deletePartyInfo(index, type) {
      let deleteObj = {}
      let deleteList = []
      this.$alert("确定要删除被告当事人数据吗", "警告", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            if (type == 'pla') {
              if (this.plaList[index].id <= 0) {
                this.plaList.splice(index, 1);
                return;
              }
              deleteObj = this.plaList[index]
              deleteList = this.plaList
            } else {
              if (this.defList[index].id <= 0) {
                this.defList.splice(index, 1);
                return;
              }
              deleteObj = this.defList[index]
              deleteList = this.defList
            }

            deleteParty(deleteObj.id).then((response) => {
              if (response.statusCode == 2000) {
                deleteList.splice(index, 1);
                this.$message({
                  duration: 5000,
                  message: "删除成功",
                  type: "info",
                });
                this.getList()
              } else {
                this.$message({
                  duration: 5000,
                  message: response.message,
                  type: "error",
                });
              }

            });

          }
        },
      });
    },
    submitBaseForm(formName) {
      if (this.caseInfo.caseStatus == "提交法院") {
        this.baseRules["courtSubDate"][0].required = true;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateLiveCaseInfo(this.id, this.caseInfo).then(res => {
            if (res.statusCode == 2000)
              this.$message.success('保存成功')
            this.getList()
          })
        } else {
          return false;
        }
      });
    },
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const token = util.cookies.get("token");
          this.$refs.upload.submit();
          this.fileData.append("bankId", this.CaseForm.bankId);
          this.fileData.append("batchId", this.CaseForm.batchId);
          this.fileData.append(
            "entrustmentDate",
            this.CaseForm.entrustmentDate
          );

          addCaseInfo(this.fileData, token).then((response) => {
            if (response.statusCode == 2000) {
              this.centerDialogVisible = false;
              this.$message.success("上传成功");
              this.getCastAllInfo();

              // this.getList();
            } else {
              this.$message({
                duration: 5000,
                message: response.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.cid = this.id;
    this.getList()
    this.element.caseId = this.id
    this.element.contractYear = 0
    this.head = {
      authorization: "Bearer " + util.cookies.get("token"),
    };
    this.courtName = this.$store.state.d2admin.data.courtList;
    this.caseStatus = this.$store.state.d2admin.data.caseStatus;
    this.applicationType = this.$store.state.d2admin.data.applicationType;
  },
};
</script>
<style scoped>
.regBody>>>.el-dialog {
  margin-top: 0px !important;
  background-color: red !important;
}

.el-select .el-input {
  width: 330px;
}

.el-collapse-item:last-child {
  margin-bottom: 0px;
}

#body>>>.el-collapse {
  border: none;
}

#body .el-collapse .el-collapse-item>>>.el-collapse-item__header {
  height: 58px !important;
}

#body>>>.el-collapse-item__header {
  border: none;
}

#body>>>.is-process {
  color: #c0c4cc;
}

#body>>>.is-process>.el-step__icon {
  border: 2px solid #c0c4cc;
}

.caseInfoItemHead {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  background: #409eff;
  color: #fff;
}

.itemHead {
  width: 98.5%;
  margin-top: 20px;
  padding: 10px;
  background: linear-gradient(to left top, white, skyblue);
}

.itemName {
  width: 100%;
  text-align: center;
  font-weight: bold;
  font-size: 1.5em;
  background: #f2f1f7;
  justify-content: center;
}

.regBody>>>.el-upload-list__item {
  display: none !important;
}

.ar {
  position: absolute;
  top: 50%;
  right: 15px;
  z-index: 1000;
  border-radius: 14px;
  animation: arrowloadRight 2s infinite;
}

.lr {
  position: absolute;
  left: 0;
  top: 50%;
  /* bottom: 14px; */
  z-index: 1000;
  border-radius: 14px;
  animation: arrowload 2s infinite;
}

@keyframes arrowload {
  0% {
    opacity: 0;
    transform: translate(30px);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(0px);
  }
}

@keyframes arrowloadRight {
  0% {
    opacity: 0;
    transform: translate(-30px);
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(0px);
  }
}

.lr:nth-child(1) {
  animation-delay: -0.4s;
}

.lr:nth-child(2) {
  animation-delay: -0.2s;
}

.lr:nth-child(3) {}

.ar:nth-child(1) {
  animation-delay: -0.4s;
}

.ar:nth-child(2) {
  animation-delay: -0.2s;
}

.ar:nth-child(3) {}

.regBody>>>.docx {
  margin: 0 auto !important;
}

li {
  line-height: 40px;
  text-align: center;
  list-style: none;
}

.sidebar:not(:last-child) {
  border-bottom: #f5f5f5 solid 1px;
}

li:hover {
  color: #fff;
  background-color: #ff8000;
}

.sidebar {
  position: fixed;
  top: 50%;
  right: 50px;
  /* left: 50%; */
  width: 128px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 8px;
  padding: 0;
  transform: translateY(-50%);
  /* box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.05); */
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05),
    0px 3px 5px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04);
}

a {
  display: block;
  width: 100%;
  height: 100%;
  color: #333;
  text-decoration: none;
}

.nextCase {
  position: absolute;
  right: 10px;
  top: 50%;
  z-index: 100;
  display: flex;

  flex-direction: column;
}

.sidebar2 {
  justify-content: center;
  position: fixed;
  bottom: 10px;
  width: 80vw;
  /* height: 27[]; */
  margin: 0 10vw;
  /* justify-content: space-between; */
}

.sidebar2 div {
  /* border-radius: 14px; */
  width: 128px;
  text-align: center;
  background-color: white;
  /* box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.05),
    0px 3px 5px 0px rgba(0, 0, 0, 0.06), 0px 2px 4px -1px rgba(0, 0, 0, 0.04); */
  /* box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4); */
  box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4),
    -3px -2px 4px 0px rgba(0, 0, 0, 0.4);
}

.navigation {
  padding: 4px;
  /* border-radius: 14px; */
  /* box-shadow: 7px 5px 4px rgba(0, 0, 0, 0.4),
              -5px -20px 30px 0px rgba(0, 0, 0, 0.4); */
  bottom: 10px;
}

.navigation:hover {
  background-color: #ff8000;
  cursor: pointer;
}

.sperater {
  background-color: #409eff;
  height: 90%;
  width: 11px;
  position: absolute;
  top: 8%;
  right: 50%;
}

.docxRefPar .el-backtop {
  right: 50% !important;
}
</style>
